import { CSSBase } from "@twind/core";

export const styles: CSSBase = {
    ":host": {
        "--hc-background": "0 0% 98%",
        "--hc-foreground": "0 0% 9%",

        "--hc-card": "0 0% 98%",
        "--hc-card-foreground": "0 0% 21%",

        "--hc-popover": "0 0% 100%",
        "--hc-popover-foreground": "222.2 84% 4.9%",

        "--hc-primary": "var(---hc-primary)",
        "--hc-primary-foreground": "0 0% 100%",

        "--hc-secondary": "var(---hc-secondary)",
        "--hc-secondary-foreground": "var(---hc-secondary-foreground)",

        "--hc-muted": "0 0% 95%",
        "--hc-muted-foreground": "0 0% 21%",

        "--hc-accent": "0 0% 98% 1" /* used for badge */,
        "--hc-accent-foreground": "0 0% 32%" /* used for badge */,

        "--hc-destructive": "0 84.2% 60.2%",
        "--hc-destructive-foreground": "210 40% 98%",

        "--hc-border": "0 0% 78%, 1",
        "--hc-input": "214.3 31.8% 91.4%",
        "--hc-ring": "222.2 84% 4.9%",

        "--hc-border-radius-none": "0p",
        "--hc-border-radius-sm": "2px",
        "--hc-border-radius-md": "6px",
        "--hc-border-radius-lg": "8px",
        "--hc-border-radius-xl": "12px",
        "--hc-border-radius-2xl": "16px",
        "--hc-border-radius-3xl": "24px",
        "--hc-border-radius-full": "9999px",
        "--hc-border-radius-default": "4px",
    },
    ".dark": {
        "--hc-background": "222.2 84% 4.9%",
        "--hc-foreground": "210 40% 98%",

        "--hc-card": "222.2 84% 4.9%",
        "--hc-card-foreground": "210 40% 98%",

        "--hc-popover": "222.2 84% 4.9%",
        "--hc-popover-foreground": "210 40% 98%",

        "--hc-primary": "210 40% 98%",
        "--hc-primary-foreground": "0, 0%, 100%, 1",

        "--hc-secondary": "217.2 32.6% 17.5%",
        "--hc-secondary-foreground": "210 40% 98%",

        "--hc-muted": "217.2 32.6% 17.5%",
        "--hc-muted-foreground": "215 20.2% 65.1%",

        "--hc-accent": "217.2 32.6% 17.5%",
        "--hc-accent-foreground": "210 40% 98%",

        "--hc-destructive": "0 62.8% 30.6%",
        "--hc-destructive-foreground": "210 40% 98%",

        "--hc-border": "217.2 32.6% 17.5%",
        "--hc-input": "217.2 32.6% 17.5%",
        "--hc-ring": "212.7 26.8% 83.9%",
    },
    "*": {
        "@apply": "border-border",
        "font-feature-settings": "'ss04' on",
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
    },
    html: {
        "font-family": '"DM Sans", system-ui, sans-serif',
    },
    body: {
        "@apply": "bg-background",
        "-webkit-overflow-scrolling": "auto",
    },
    // Dialog
    ".DialogOverlay": {
        opacity: 0,
    },
    ".DialogContent": {
        opacity: 0,
    },
    ".DialogOverlay[data-state='open']": {
        animation: "fadeIn 300ms ease-out forwards",
    },
    ".DialogOverlay[data-state='closed']": {
        opacity: 1,
        animation: "fadeOut 300ms ease-out forwards",
    },
    ".DialogContent[data-state='open']": {
        animation: "GrowIn 500ms ease-out forwards",
    },
    ".DialogContent[data-state='closed']": {
        opacity: 1,
        animation: "GrowOut 500ms ease-out forwards",
    },
};

export const keyframes = `
@keyframes fadeIn {
    from {
        opacity: 0;

    }
    to {
        opacity: 1;

    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

@keyframes GrowIn {
    from {
        opacity: 0;
        scale: 0.95;
    }
    to {
        opacity: 1;
        scale: 1;
    }
}

@keyframes GrowOut {
    from {
        opacity: 1;
        scale: 1;
    }
    to {
        opacity: 0;
        scale: 0.95;
    }
}
`;
